export default __webpack_public_path__ + "alberta-download.53efbc7c3493fd1737d3.svg";